import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

type OnSuccess = (status: Immutable.Map<string, any>) => void;
type OnError = (error: ErrorData) => void;

function b64EncodeUnicode (str: string) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  const toSolidBytes = (subString: string, p1: any) => {
    return String.fromCharCode(parseInt('0x' + p1));
  };

  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, toSolidBytes));
}

function fetch (onSuccess: OnSuccess, onError: OnError): void {
  ConnectionSupport.post(
    'getUsageStatus',
    {},
    (data) => onSuccess(Immutable.Map(data)),
    onError
  );
}

function optIn (userName: string, password: string, onSuccess: OnSuccess, onError: OnError): void {
  ConnectionSupport.post(
    'usageOptIn',
    {authType: 'Basic', cred: b64EncodeUnicode(userName + ':' + password)},
    (data) => onSuccess(Immutable.Map(data)),
    onError
  );
}

function optOut (removeData: boolean, onSuccess: OnSuccess, onError: OnError): void {
  ConnectionSupport.post(
    'usageOptOut',
    {removeData: removeData},
    (data) => onSuccess(Immutable.Map(data)),
    onError
  );
}

const UsageConnection = {
  fetch,
  optIn,
  optOut
};

export default UsageConnection;
